import React, { useContext, useEffect, useState } from "react";
import Button from "shared/components/Buttons/Button";
import AppContext from "context/AppContext";
import { useHistory, useParams } from "react-router-dom";
import apiCalls from "shared/utils/apiCalls";
import { Challenge } from "shared/types/challenges";
import Input from "shared/components/Input/Input";

const EditChallengeDetails = () => {
  const [challenge, setChallenge] = useState<Challenge>();

  const [thumbnailImage, setThumbnailImage] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [price, setPrice] = useState<string>("");
  const [level, setLevel] = useState<number>(0);
  const [order, setOrder] = useState<number>(0);
  const [designId, setDesignId] = useState<string>("");
  const [resourceId, setResourceId] = useState<string>("");
  const [intro, setIntro] = useState<string>("");
  const [brief, setBrief] = useState<string>("");
  const [pathSlug, setPathSlug] = useState<string>("");

  const { dispatch } = useContext(AppContext);

  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    const getChallenge = async () => {
      const res = await apiCalls(
        {
          method: "get",
          url: `/challenges/${id}`,
        },
        dispatch
      );

      if (res) {
        setChallenge(res.data);
        setName(res.data.name);
        setThumbnailImage(res.data.thumbnailImage);
        setPrice(res.data.price);
        setLevel(res.data.level);
        setDesignId(res.data.designId);
        setResourceId(res.data.resourceId);
        setIntro(res.data.intro);
        setBrief(res.data.brief);
        setOrder(res.data.order);
        setPathSlug(res.data.pathSlug);
      }
    };

    if (!challenge) {
      getChallenge();
    }

    // eslint-disable-next-line
  }, []);

  const onSubmit = async (e: any) => {
    e.preventDefault();

    const res = await apiCalls({
      method: "put",
      data: {
        tags: challenge?.tags,
        thumbnailImage,
        name,
        price,
        level,
        designId,
        resourceId,
        intro,
        brief,
        order,
        pathSlug,
      },
      url: `/challenges/${id}`,
    });

    if (res) {
      history.push(`/challenges/${id}`);
    }
  };

  return (
    <div>
      <h2>Edit {challenge?.name}</h2>
      <form onSubmit={onSubmit}>
        <Input
          name="thumbnailImage"
          label="Thumbnail Image"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          onChange={(e: any) => setThumbnailImage(e.target.value)}
          value={thumbnailImage}
        />

        <Input
          name="name"
          label="Name"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          value={name}
          onChange={(e: any) => setName(e.target.value)}
        />

        <Input
          name="price"
          label="free or premium"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          onChange={(e: any) => setPrice(e.target.value)}
          value={price}
        />

        <Input
          name="order"
          label="Order"
          variant="outlined"
          fullWidth
          margin="normal"
          type="number"
          required
          onChange={(e: any) => setOrder(parseInt(e.target.value))}
          value={order}
        />

        <Input
          name="level"
          label="Level"
          variant="outlined"
          fullWidth
          margin="normal"
          type="number"
          required
          onChange={(e: any) => setLevel(parseInt(e.target.value))}
          value={level}
        />

        <Input
          name="designId"
          label="Design Id"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          onChange={(e: any) => setDesignId(e.target.value)}
          value={designId}
        />

        <Input
          name="resourceId"
          label="Resource Id"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          onChange={(e: any) => setResourceId(e.target.value)}
          value={resourceId}
        />

        <Input
          name="intro"
          label="Intro (Challenge Card)"
          variant="outlined"
          fullWidth
          margin="normal"
          rows="3"
          multiline
          required
          onChange={(e: any) => setIntro(e.target.value)}
          value={intro}
        />

        <Input
          name="brief"
          label="Brief (User Stories)"
          variant="outlined"
          fullWidth
          margin="normal"
          rows="15"
          multiline
          required
          onChange={(e: any) => setBrief(e.target.value)}
          value={brief}
        />

        <Input
          name="pathSlug"
          label="Path Slug"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          value={pathSlug}
          onChange={(e: any) => setPathSlug(e.target.value)}
        />

        <div>
          <Button type="submit" aria-label="submit">
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditChallengeDetails;
